module.exports = __webpack_public_path__ + "static/media/2.0d8c1d77.png";